import React, { useState } from "react";
import "./Ordered_Product_details_tabs.css";
import { Tab, Nav } from "react-bootstrap";
import About from "./about/About";
import Use_clean from "./use_clean/Use_clean";
import Features from "./features/Features";
import Description from "./description/Description";

function Ordered_Product_details_tabs() {
  const [activeKey, setActiveKey] = useState("description");

  return (
    <>
      <section className="Ordered_Product_details_tabs">
          <Tab.Container activeKey={activeKey} onSelect={(k) => setActiveKey(k)}>
            {/* Tabs Header */}
            <div className="tabs_header">
              <Nav className="tabs_nav">
                <Nav.Item>
                  <Nav.Link eventKey="description" className="tab_link">
                    Product Description
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link eventKey="features" className="tab_link">
                    Product features
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link eventKey="use_clean" className="tab_link">
                    Instructions to Use & Clean
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link eventKey="about" className="tab_link">
                    About the Century Old Mittal Group
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </div>

            {/* Tabs Content */}
            <div className="tabs_body">
              <Tab.Content>
                <Tab.Pane eventKey="description">
                 
                  <Description/>
                </Tab.Pane>

                <Tab.Pane eventKey="features">
                  <Features/>
                </Tab.Pane>

                <Tab.Pane eventKey="use_clean">
                 <Use_clean/>
                </Tab.Pane>

                <Tab.Pane eventKey="about">
                 <About/>
                </Tab.Pane>
              </Tab.Content>
            </div>
          </Tab.Container>
      </section>
    </>
  );
}

export default Ordered_Product_details_tabs;
